import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Collapse, Typography } from 'antd';
import React, { useState } from 'react';
import * as S from './DealRoomSection.styles';
import { PanelItem } from './ThirdPartyInsurance';

const { Title, Text } = Typography;
export const { Panel } = Collapse;

const InsuranceCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">
          {`במקרה של תאונת עובד או עובדת בבניין: ביטוח חבות מעבידים מספק השלמת פיצוי, מעבר למה שביטוח לאומי משלם. סכום הפיצוי נקבע בהסכמה בין חברת הביטוח והתובע (עובד/ת). אם אין הסכמה, בית המשפט יפסוק בהתאם למקרה ובהתאם למידת האחריות של ועד הבית. גובה הכיסוי הביטוחי יכול להגיע עד 20,000,000 ₪.`}
        </Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper>
        <Title level={2} className="main-title regular">
          {`במקרה של תביעת עובד או עובדת קבלן:במקרה של תביעת עובד או עובדת קבלן:`}
        </Title>
        <Text className="sub-text">
          {`ועד הבית יידרש להוכיח שלא התקיימו יחסי עובד מעביד. בית המשפט יבדוק היבטים שונים שמשקפים את אופי ההעסקה בפועל. למשל: חוזה, אופי העבודה ועוד. הביטוח יכסה עבור ועד הבית את ההגנה המשפטית בתהליך התביעה.`}
        </Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <S.ListWrapper>
          <S.ListItem>{`עובד ניקיון המועסק בצורה ישירה על ידי ועד הבית, מנקה בכל יום שטח אחר במתחם המגורים המשותף, נפצע תוך כדי עבודתו עם מכשיר שטיפה.`}</S.ListItem>
          <S.ListItem>{`אב בית המועסק בצורה ישירה וקבועה על ידי ועד הבית, טיפס על סולם לצורך החלפת מנורות בשטח הרכוש המשותף, נפל מהסולם עקב שבר שלב בסולם השייך לבניין.`}</S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const InsuranceNotCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">
          {`ביטוח חבות מעבידים אינו מכסה תאונות עבודה של עובדי קבלן. קבלן המשנה צריך לרכוש ביטוח חבות מעבידים לעובדיו השכירים. קבלן חיצוני יכול לתבוע את הבניין על פציעה בעבודה בעקבות רשלנות של הבניין והארוע יכוסה במסגרת פרק צד ג'.`}
        </Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <S.ListWrapper>
          <S.ListItem>{`בעל מקצוע הגיע להתקין גופי תאורה בחניון תת קרקעי, ונפגע תוך כדי עבודתו. הארוע אינו מכוסה בפרק חבות מעבידים כיוון שאין יחסי עובד מעביד בין ועד הבית (מזמין העבודה) ובעל המקצוע (עצמאי).`}</S.ListItem>
          <S.ListItem>{`עובד שכיר של חברת גינון נפגע בצורה קשה (אצבעו נכרתה) תוך כדי הפעלת כלי מסור חשמלי בגינה. ביטוח חבות מעבידים אינו מכסה את העובד, על העובד לתבוע את ביטוח חבות מעבידים של המעסיק שלו.`}</S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const FAQs: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <S.ListWrapper className="number">
          <S.ListItem>
            <S.ListTitle>{`אם ועד הבית לא משלם ביטוח לאומי, ניתן לתבוע את חבות מעבידים?`}</S.ListTitle>
            <S.ListContent>{`אין קשר בין ביטוח לאומי לבין ביטוח חבות מעבידים, ביטוח לאומי הוא חוק במדינת ישראל שמטרתו להגן על העובד. חבות מעבידים הוא ביטוח פרטי שמגן על הבניין ונועד לתת פתרון לתביעות שהן מעבר למה שביטוח לאומי משלם.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>
              {`אם העובד מוציא חשבונית או שהוא עובד של חברת הניהול, האם הוועד צריך לרכוש `}
              <br />
              {`ביטוח חבות מעבידים?`}
            </S.ListTitle>
            <S.ListContent>{`יחסי עובד-מעביד, נפגע כתוצאה מעבודתו בבניין ומחליט לתבוע את הבניין. גם אם העובד אינו צודק בטענתו, מספיק שהוא ייקח עו"ד ויגיש תביעה נגד הבניין, וכתוצאה מכך, הבניין יצטרך להתגונן מפני התביעה. היתרון בביטוח חבות מעבידים מעבר להיותו ביטוח זול מאוד הוא שברוב חברות הביטוח אין בו השתתפות עצמית, והוא נותן הגנה משפטית במקרה של תביעה.`}</S.ListContent>
            <S.ListContent>{`ללא רכישה של פרק חבות מעבידים, חברת הביטוח לא תוכל להגן על ועד הבית בבית משפט ולכן מומלץ לכל בניין לרכוש את הכיסוי כהגנה משפטית.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>
              {`האם ביטוח חבות מעבידים מכסה אם הזמנתי אינסטלטור לבניין והוא נפגע`}
              <br />
              {`כתוצאה מעבודתו?`}
            </S.ListTitle>
            <S.ListContent>{`לא.
אינסטלטור שמגיע לבניין אינו מקיים יחסי עובד-מעביד עם ועד הבית ולכן אין כיסוי לתאונה הזו. אם האינסטלטור נפגע כתוצאה מהרכוש המשותף (למשל נפל בגלל מדרגה שבורה) ויש לבניין ביטוח צד ג' - יהיה כיסוי לתאונה הזו.
ללא רכישה של פרק חבות מעבידים, חברת הביטוח לא תוכל להגן על ועד הבית בבית משפט ולכן מומלץ לכל בניין לרכוש את הכיסוי כהגנה משפטית.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>
              {`המנקה של הבניין תבע את הבניין כי לא שילמנו עבורו פנסיה וימי חופש, האם ביטוח`}
              <br />
              {`חבות מעבידים מכסה תביעה זו?`}
            </S.ListTitle>
            <S.ListContent>{`לא. ביטוח חבות מעבידים מגן על הבניין במידה שהעובד נפגע פיזית כתוצאה מעבודתו.`}</S.ListContent>
            <S.ListContent>{`הביטוח לא מכסה תביעות על עניינים סוציאליים.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`למה צריך ביטוח חבות מעבידים אם ביטוח לאומי משלם במקרה של תאונה?`}</S.ListTitle>
            <S.ListContent>{`הפיצוי שניתן על ידי ביטוח לאומי אינו מספק, ברבים מהמקרים, ולכן העו"ד יגיש תביעה גם נגד ביטוח לאומי וגם נגד המעסיק – ועד הבית.`}</S.ListContent>
          </S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const panelItems: PanelItem[] = [
  {
    key: '1',
    title: 'מה הביטוח מכסה?',
    content: <InsuranceCover />,
  },
  {
    key: '2',
    title: `מה הביטוח לא מכסה?`,
    content: <InsuranceNotCover />,
  },
  {
    key: '3',
    title: `שאלות ותשובות נפוצות`,
    content: <FAQs />,
  },
];
export const EmployersLiability: React.FC = () => {
  const [activeKey, setActiveKey] = useState<string | string[]>();

  return (
    <S.Wrapper>
      <S.Header>
        <Title level={2} className="main-title">
          {`חבות מעבידים`}
        </Title>
        <Title level={2} className="main-title">{`למה צריך ביטוח חבות מעבידים?`}</Title>
        <Text className="sub-text">{`ביטוח צד ג' לא מכסה תביעות של עובדים ועובדות בבניין. לשם כך יש לנו את ביטוח חבות מעבידים. ביטוח זה מספק את ההשלמה ומגן על ועד הבית מפני תביעות עובדים ועובדות בבניין, במקרים של תאונות שנגרמו כתוצאה מרשלנות של הוועד והבניין.`}</Text>
      </S.Header>
      <S.IconCollapseWrapper>
        <S.IconCollapse accordion className="custom-collapse" activeKey={activeKey} onChange={setActiveKey}>
          {panelItems.map((item) => (
            <Panel
              key={item.key}
              showArrow={false}
              header={
                <S.PanelHeader>
                  <S.IconWrapper>
                    {activeKey === item.key ? (
                      <MinusOutlined className="plus-icon" />
                    ) : (
                      <PlusOutlined className="plus-icon" />
                    )}
                  </S.IconWrapper>
                  <Text strong className="header-text">
                    {item.title}
                  </Text>
                </S.PanelHeader>
              }
            >
              {item.content}
            </Panel>
          ))}
        </S.IconCollapse>
      </S.IconCollapseWrapper>
    </S.Wrapper>
  );
};
